import { Component } from 'solid-js'
import GenerateImageOptionButton from './GenerateImageOptionButton'

const GenerateImageBodyOptions: Component<{
  updatePrompt: (value: string, replacePrompt: boolean) => void
}> = (props) => {
  return (
    <div class="flex flex-row flex-wrap gap-4">
      <GenerateImageOptionButton title="Slim" value="slim body" onClick={props.updatePrompt} />
      <GenerateImageOptionButton
        title="Muscular"
        value="muscular body"
        onClick={props.updatePrompt}
      />
      <GenerateImageOptionButton title="Chubby" value="chubby body" onClick={props.updatePrompt} />
      <GenerateImageOptionButton title="Skinny" value="skinny body" onClick={props.updatePrompt} />
      <GenerateImageOptionButton title="Tall" value="tall body" onClick={props.updatePrompt} />
      <GenerateImageOptionButton title="Short" value="short body" onClick={props.updatePrompt} />
      <GenerateImageOptionButton
        title="Average"
        value="average body"
        onClick={props.updatePrompt}
      />
      <GenerateImageOptionButton title="Curvy" value="curvy body" onClick={props.updatePrompt} />
    </div>
  )
}

export default GenerateImageBodyOptions
